function checkPreorders() {
  document.querySelectorAll(".boost-sd__format-currency").forEach((price) => {
    price.innerText === "$0" && (price.innerText = "");
  });
}
const productIds = [
  "8783886385385",
  "8783885959401",
  "8783884779753",
  "8783883534569",
  "8783881961705",
  "8783880782057",
  "8783879602409",
  "8783877701865",
  "8783875899625",
  "8783873704169",
  "8783872557289",
  "8783871115497",
  "8783869837545",
  "8783867773161",
  "8783866101993",
  "8783864398057",
  "8783861842153",
  "8783860269289",
  "8783858073833",
  "8783856042217",
  "8783853486313",
  "8783848243433",
  "8783847424233",
  "8783846670569",
  "8783844540649",
  "8783843393769",
  "8783839625449",
  "8783839494377",
  "8783839035625",
  "8783838249193",
  "8783845425385",
  "8783840837865",
];
function checkDisabled() {
    productIds.forEach((productId) => {

      let product = document.getElementById(productId);
      if (product) {
        let button = product.querySelector(".boost-sd__button");
        button
          ? (button.removeAttribute("disabled"),
            (button.querySelector(".boost-sd__button-text").textContent =
              "Pre-order"),
            updateButtonClasses(button))
          : console.warn(
              `Button with class 'boost-sd__button' not found for product with ID ${productId}.`
            );
      } else console.warn(`Product with ID ${productId} not found.`);
    });
}
function updateButtonClasses(button) {
    if (button.classList.contains("boost-sd__btn-add-to-cart")) {
    button.classList.remove("boost-sd__btn-add-to-cart");
    button.classList.add("js-btb-button");
  } else {
    button.classList.add("js-btb-button");
  }
}
document.addEventListener("DOMContentLoaded", function (event) {
  let intervalId = setInterval(function () {
    document.querySelectorAll(".boost-sd__format-currency").length > 0 &&
      (clearInterval(intervalId), checkPreorders(), checkDisabled());
  }, 1e3);
});

const customize = {
  updateProductItemGrid: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Add extra information',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            // Start customization--------------------------------------------
            let productData = element.getParams().props.product;
            let productId = productData.id;
            if (productData?.split_product) {
              productId = productData.variant_id;
            }
            let productItem = document.querySelector('[data-product-id="' + productId + '"]');
            if (productItem) {
              /* use pure js here */
              /* Example - Add percent sale info */
              if (productData.price_min == 0 && !productData.available) {
                  productItem.classList.add('hide-price');
                  const ATCBtn = productItem.querySelector('.boost-sd__product-info > .boost-sd__button');
                  if (ATCBtn && ATCBtn.querySelector('.boost-sd__button-text')){
                    ATCBtn.querySelector('.boost-sd__button-text').innerText = 'Preoder';
                    ATCBtn.setAttribute('aria-label', 'Preoder');
                  }
                  const preOrderBtn = productItem.querySelector('button[aria-label="Preoder"]');
                  if (preOrderBtn) {
                    preOrderBtn.classList.add('wholesale-section-button', 'js_btb_form_action');
                    preOrderBtn.disabled = false;
                  }
              }
              /* End example */
            }
            // End-------------------------------------------------------------
          } catch (e) {
            console.warn(e);
          }
        }
      }),
    });
  }
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);
